export enum FilterInputType {
  From = 'From',
  To = 'To'
}
